import { useField } from "formik";

import { getFieldTestId } from "utils/formik";

import { Switch3 } from "../elements";
import { FieldProps } from "./propTypes";

export const Switch3Field = (props) => {
  const { name, dataTestId } = props;

  const [field, meta, { setValue }] = useField({
    ...props,
    type: "select",
  });

  return (
    <Switch3
      {...field}
      {...meta}
      {...props}
      dataTestId={dataTestId || getFieldTestId(name)}
      onSelect={setValue}
    />
  );
};

Switch3Field.propTypes = FieldProps;
